module.exports = __webpack_public_path__ + "static/prodega-5e0a5dd252aefe483ceff919fbc38ffe.png";